//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: "serviceCustom",
    components: {},
    data() {
        return {
            projectId: 0,
            list: []
        };
    },
    methods: {
        getProjectPhones(id) {
            var page = {
                projectId: id,
                maxResultCount: 20,
                skipCount: 0
            };
            abp.ajax.post('/api/services/app/Project/SearchContactNumbers', page).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                // this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                // this.loading = false;
            });
        }
    },
    created() {
        var p = localStorage.getItem('Select-ProjectId');
        if (p) {
            this.projectId = parseInt(p);
            if (this.projectId > 0) {
                this.getProjectPhones(this.projectId);
            }
        }
    }
}
